import { LogOut, RefreshCw } from 'lucide-react';
import { useAuth } from '../contexts/AuthProvider';
import BoarMark from './BoarMark';

// Shown when you're signed in but your account isn't granted Sangly — or, when
// `page` is given, isn't granted that one page of it (a Virgy module, see
// users/access.py). The boar guards the trough — a light, bilingual (FR/NL,
// + a cheeky Njet) refusal.
export default function BoarDenied({ page }) {
  const { user, logout } = useAuth();
  const email = user?.email || '';

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background p-6">
      <style>{`
        @keyframes boar-nope { 0%,100%{transform:rotate(-9deg)} 50%{transform:rotate(9deg)} }
        @keyframes stamp-in { 0%{transform:rotate(-6deg) scale(2.4);opacity:0} 60%{opacity:1}
                              75%{transform:rotate(-6deg) scale(.94)} 100%{transform:rotate(-6deg) scale(1)} }
        .boar-nope{ animation:boar-nope 1.1s ease-in-out infinite; transform-origin:52% 78%; }
        .denied-stamp{ animation:stamp-in .5s cubic-bezier(.2,.8,.2,1) .15s both; }
        @media (prefers-reduced-motion: reduce){ .boar-nope,.denied-stamp{ animation:none } }
      `}</style>

      {/* oversized watermark word */}
      <div aria-hidden className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <span className="select-none text-[26vw] font-black leading-none tracking-tighter text-primary/[0.05]">
          NJET
        </span>
      </div>

      <div className="relative z-10 w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-pop">
        <div className="mx-auto mb-5 w-fit">
          <div className="boar-nope inline-block">
            <BoarMark size={104} rounded={30} />
          </div>
          <div className="denied-stamp mx-auto -mt-6 w-fit rounded-md border-2 border-rose-500/80 px-3 py-1
                          text-[13px] font-extrabold uppercase tracking-wide text-rose-600/90">
            Accès refusé · Geen toegang
          </div>
        </div>

        <h1 className="text-2xl font-bold">
          Njet. <span className="font-medium text-muted-foreground">Non. Nee. Nope.</span>
        </h1>

        <p className="mt-3 text-[14px] leading-relaxed text-muted-foreground">
          You're signed in{email && <> as <b className="text-foreground">{email}</b></>}, but this account
          isn't on {page ? <>the guest list for <b className="text-foreground">{page}</b></> : <>Sangly's guest list</>} yet.
          The boar guards the trough. 🐗
        </p>
        <p className="mt-2 text-[13px] text-muted-foreground">
          Ask an admin to grant you access, then hit retry.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <button onClick={() => window.location.reload()}
            className="inline-flex h-9 items-center gap-1.5 rounded-md bg-primary px-3.5 text-[13px] font-semibold text-primary-foreground transition hover:opacity-90">
            <RefreshCw className="h-4 w-4" /> I've been granted — retry
          </button>
          <button onClick={() => logout()}
            className="inline-flex h-9 items-center gap-1.5 rounded-md border border-border bg-card px-3.5 text-[13px] font-medium text-muted-foreground transition hover:bg-muted">
            <LogOut className="h-4 w-4" /> Switch account
          </button>
        </div>
      </div>
    </div>
  );
}
